import HttpClient from "application/services/http-client";
import { PaginationResponse } from "models/pagination-response";
import { IArticlesListRequest } from "models/request/articles-list-request";
import { IBannersListRequest } from "models/request/banners-list-request";
import { IExportDataRequest } from "models/request/export-data-request";
import { ILinkServicesListRequest } from "models/request/link-services-list-request";
import { INewsPagedRequest } from "models/request/news-paged-request";
import { IOfficialDiaryPagedRequest } from "models/request/official-diary-paged-request";
import { IPublicationPagedReqeust } from "models/request/publication-paged-request copy";
import { IArticlesListResponse } from "models/response/articles-list-response";
import { IBannersListResponse } from "models/response/banners-list-response";
import { ICategoriesNewsListResponse } from "models/response/categories-news-list-response";
import { ICategoriesPublicationListResponnse } from "models/response/categories-publication-list-responnse";
import { FileDownloadResponse } from "models/response/file-download-response";
import { IGovernamentalStructureReponse } from "models/response/governamental-strutucture-response";
import { ILinkServicesListResponse } from "models/response/link-services-list-response";
import { INewsRespomse } from "models/response/news-response";
import { INewsPagedRespomse } from "models/response/news-paged-response";
import { IOfficialDiaryPagedResponse } from "models/response/official-diary-paged-response";
import { IPublicationPagedResponse } from "models/response/publication-paged-response";
import { IPublisingVehicleListReponse } from "models/response/publishing-vehicle-list-repsonse";
import { IMenusListRequest } from "models/request/menus-list-request";
import { IMenuResponse } from "models/response/menu-response";
import { ICustomPageRequest } from "models/request/custom-page-request";
import { ICustomPageResponse } from "models/response/custom-page-response";

const defaultPath = 'MunicipalPortal';


const listArticles = async (params: IArticlesListRequest): Promise<IArticlesListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Articles`,
        params: params
    }).then((response) => Object.assign([] as unknown as IArticlesListResponse, response.data));
};

const listBanners = async (params: IBannersListRequest): Promise<IBannersListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Banners`,
        params: params
    }).then((response) => response.data as IBannersListResponse[]);
};


const listLinkServices = async (params: ILinkServicesListRequest): Promise<ILinkServicesListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/LinkServices`,
        params: params
    }).then((response) => response.data as ILinkServicesListResponse[]);
};
const listCategoriesNews = async (): Promise<ICategoriesNewsListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoryNews`,
    }).then((response) => response.data as ICategoriesNewsListResponse[]);
};
const listNews = async (params: INewsPagedRequest): Promise<PaginationResponse<INewsPagedRespomse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/News`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<INewsPagedRespomse>(), response.data));
};
const listOfficialDaily = async (params: IOfficialDiaryPagedRequest): Promise<PaginationResponse<IOfficialDiaryPagedResponse>> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/OfficialDaily`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IOfficialDiaryPagedResponse>(), response.data));
};

const listPublication = async (params: IPublicationPagedReqeust): Promise<PaginationResponse<IPublicationPagedResponse>> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Publication`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IOfficialDiaryPagedResponse>(), response.data));
};
const listCategoryPublication = async (): Promise<ICategoriesPublicationListResponnse[]> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoriesPublication`,
    }).then((response) => Object.assign([] as ICategoriesPublicationListResponnse[], response.data));
};
const listPublisingVehicle = async (): Promise<IPublisingVehicleListReponse[]> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PublishingVehicle`,
    }).then((response) => Object.assign([] as IPublisingVehicleListReponse[], response.data));
};

const exportData = async (params: IExportDataRequest): Promise<FileDownloadResponse> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/ExportData`,
        params: params
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const getGovernamentalStrucutre = async (id: number): Promise<IGovernamentalStructureReponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/GovernamentalStructure/${id}`
    }).then((response) => Object.assign({} as IGovernamentalStructureReponse, response.data));
};


const getNews = async (id: number): Promise<INewsRespomse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/News/${id}`,

    }).then((response) => Object.assign({} as INewsRespomse, response.data));
};

const listGovernamentalSctructure = async (): Promise<IGovernamentalStructureReponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/GovernamentalStructure`
    }).then((response) => response.data as IGovernamentalStructureReponse[]);
};

const listMenus = async (): Promise<IMenuResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Menus`
    }).then((response) => response.data as IMenuResponse[]);
};

const getCustomPage = async (slug: string): Promise<ICustomPageResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CustomPages/${slug}`
    }).then((response) => Object.assign({} as ICustomPageResponse, response.data));
};


const MunicipalPortalAAppService = {
    listLinkServices, exportData, getGovernamentalStrucutre, listGovernamentalSctructure, getNews, listBanners, listPublisingVehicle, listArticles, listNews, listCategoriesNews, listOfficialDaily, listPublication, listCategoryPublication, listMenus, getCustomPage
};

export default MunicipalPortalAAppService;